import React from 'react'
import cn from 'classnames'
import { css } from '@emotion/react'
import { Form } from 'util/ui'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { Shopify } from '@groovehq/internal-design-system/lib/assets/icons/logos'

import sharedStyles from '../../sharedForm/styles.less'
import SaveIndicator from '../../sharedForm/SaveIndicator'
import PageHeader from '../PageHeader'
import { useTrialPage } from './hooks'
import { styles } from '../styles'
import OauthError from '../OauthError'

const TrialPage = () => {
  const {
    saving,
    confirming,
    storeName,
    startTrial,
    errorCode,
  } = useTrialPage()

  return (
    <>
      <PageHeader />
      <Form size="large" className={cn(sharedStyles.form, sharedStyles.formV3)}>
        <Form.Field>
          <label htmlFor="name">Start your trial subscription</label>
          <div
            className="hint"
            css={css`
              color: #1b1b1b !important;
            `}
          >
            To get started, you first need to confirm the trial subscription for
            your Shopify store {'"'}
            <strong>{storeName}</strong>
            {'"'}.
          </div>
        </Form.Field>
        {errorCode && (
          <Form.Field>
            <OauthError authErrorCode={errorCode} />
          </Form.Field>
        )}
        <Button
          customIcon={!saving && <Shopify />}
          onClick={startTrial}
          css={styles.shopifyButton}
          disabled={saving || confirming}
        >
          {!saving && !confirming && 'Start my trial subscription'}
          {confirming && (
            <SaveIndicator animate>
              One moment, checking your subscription
            </SaveIndicator>
          )}
          {saving && (
            <SaveIndicator animate>
              One moment, creating your subscription
            </SaveIndicator>
          )}
        </Button>
      </Form>
    </>
  )
}

export default TrialPage
